import { ParticleWaveBackground } from '../lib/ParticleWaveBackground';
import ScrollTrigger from 'gsap/ScrollTrigger';

export function initWaveBg(parent) {
  if (!parent) return;

  const inner = parent.querySelector('.wave-bg__inner');

  const animation = new ParticleWaveBackground(inner, {
    planeWidth: 12.996,
    planeHeight: 10.431,
    widthSegments: 174,
    heightSegments: 128,
    particleSize: 0.02808,
    waveHeight: 0.844,
    noiseScale: 2.4696,
    animationSpeed: 7569,
    fadePower: 0.7425,
    color: [0.9176470588235294, 0, 0.14901960784313725],
    bgColor: [0.9608, 0.9608, 0.9608],
    rotationX: -0.797964534011807,
    rotationY: 0.282743338823081,
    rotationZ: -0.0251327412287183,
    cameraPosition: [-3.04, -0.58, 10.431],
    cameraRotationX: 0,
    cameraRotationY: 0,
    cameraRotationZ: 0,
    autoStart: false,
  });

  ScrollTrigger.create({
    trigger: inner,
    start: 'top bottom',
    end: 'bottom top',
    onEnter: () => animation.startAnimation(),
    onLeave: () => animation.stopAnimation(),
    onEnterBack: () => animation.startAnimation(),
    onLeaveBack: () => animation.stopAnimation(),
  });
}

export function initWaveBgs(selector = '.js-wave-bg') {
  const blocks = document.querySelectorAll(selector);
  blocks.forEach((block) => initWaveBg(block));
}
